import React from 'react';
import { Box, Card, useTheme } from '@mui/material';
import CocoChat from 'components/coco/CocoChat';

export default function CocoPage() {
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 80px)', maxWidth: '100%' }}>
      <Card
        sx={{
          width: '100%',
          height: '100%',
          p: 2,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CocoChat />
      </Card>
    </Box>
  );
}
